var map = {
	"./gogo.dark.blue.scss": [
		63,
		47
	],
	"./gogo.dark.green.scss": [
		64,
		48
	],
	"./gogo.dark.orange.scss": [
		65,
		49
	],
	"./gogo.dark.purple.scss": [
		66,
		50
	],
	"./gogo.dark.red.scss": [
		67,
		51
	],
	"./gogo.light.blue.scss": [
		68,
		52
	],
	"./gogo.light.green.scss": [
		69,
		53
	],
	"./gogo.light.orange.scss": [
		70,
		54
	],
	"./gogo.light.purple.scss": [
		71,
		55
	],
	"./gogo.light.red.scss": [
		72,
		56
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 36;
module.exports = webpackAsyncContext;